import React from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {mobileOnly, tabletAndUp} from '../../../constants/customMedia';
import {OptionContentProps} from '../../molecules/SizeOption/OptionContent';
import {SizeOptionWithRadioButton} from '../../molecules/SizeOption/SizeOptionWithRadioButton';
import {SizeOptionProps} from '../../molecules/SizeOption/types';

export interface SizeListProps {
  className?: string;
  sizes: Array<SizeOptionProps>;
  onSizeSelect: (sizeId: number) => void;
  selectedSizeId: number | undefined;
  displayVariantPrices?: boolean;
  showVatLabelInColumn?: boolean;
}

export const SizeList: React.FC<SizeListProps & OptionContentProps> = ({
  className,
  sizes,
  onSizeSelect,
  selectedSizeId,
  displayVariantPrices,
  enableEndBadgeBellIcon,
  showVatLabelInColumn,
}) => (
  <List className={className} data-testid="sizeOptionList" tabIndex={0}>
    {sizes.map(size => {
      return (
        <SizeListItem
          key={size.id}
          data-is-selected={size.id === selectedSizeId}
        >
          <SizeOptionWithRadioButton
            {...size}
            selected={size.id === selectedSizeId || sizes.length === 1}
            onSizeSelect={onSizeSelect}
            displayVariantPrices={displayVariantPrices}
            enableEndBadgeBellIcon={enableEndBadgeBellIcon}
            showVatLabelInColumn={showVatLabelInColumn}
          />
        </SizeListItem>
      );
    })}
  </List>
);

const SizeListItem = styled.li`
  border: solid 1px ${COLORS.Grey3};
  border-bottom: none;
  :first-child {
    border-radius: 2px 2px 0 0;
  }
  :last-child {
    border-radius: 0 0 2px 2px;
    border-bottom: solid 1px ${COLORS.Grey3};
  }

  transition: background-color 0.2s ease-in-out;
  &:hover {
    cursor: pointer;
    background-color: ${COLORS.Grey4};
  }

  ${mobileOnly(css`
    &[data-is-selected='true'] {
      background-color: ${COLORS.Grey5};
    }
  `)}
`;

const List = styled.ul`
  flex: 1;
  margin: 0;
  padding: 0;
  list-style: none;

  ${tabletAndUp(
    css`
      max-width: 400px;
    `,
  )}
`;
